import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, ExternalLink } from 'lucide-react';
import { openCalendlyPopup } from '../utils/calendly';
export function StorySection() {
  return <section className="py-20 bg-[#0A0E27] relative" data-id="element-266">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-267">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-268">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-269">
            Why I Built <span className="text-[#FF5722]" data-id="element-270">CRM Kraft</span>
          </h2>
          <div className="h-1 w-20 bg-[#FF5722] mx-auto rounded-full" data-id="element-271"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-272">
          <div className="space-y-6 text-lg text-[#94A3B8] leading-relaxed" data-id="element-273">
            <p data-id="element-274">
              <strong className="text-white" data-id="element-275">
                "We automate everything except the fun."
              </strong>
            </p>
            <p data-id="element-276">
              I come from two worlds: IT and sales. This combination is rare –
              and that's what makes the crucial difference.
            </p>
            <p data-id="element-277">
              As a developer, I understand the technical requirements for a
              robust system. As a salesperson, I know the daily struggle for
              leads, the frustration of manual data entry, and the pressure of
              quarterly targets.
            </p>
            <p data-id="element-278">
              Many CRM systems are built in ivory towers. CRM Kraft was forged
              in practice. Every feature exists because it solves a real problem
              that I or my team have experienced firsthand.
            </p>

            <div className="pt-6 flex flex-col sm:flex-row gap-4" data-id="element-279">
              <Button variant="outline" rightIcon={<ArrowRight className="w-4 h-4" data-id="element-281" />} onClick={openCalendlyPopup} data-id="element-280">
                Book Free Demo
              </Button>
              <Button variant="outline" rightIcon={<ExternalLink className="w-4 h-4" data-id="element-283" />} onClick={() => window.open('https://crm-kraft.com/', '_blank', 'noopener,noreferrer')} data-id="element-282">
                Discover CRM Kraft
              </Button>
            </div>
          </div>

          <div className="relative" data-id="element-284">
            <div className="absolute inset-0 bg-gradient-to-r from-[#FF5722]/20 to-[#3B82F6]/20 blur-3xl rounded-full opacity-30" data-id="element-285"></div>
            <div className="relative bg-[#141B3A] border border-[#1E293B] rounded-2xl p-8 md:p-12" data-id="element-286">
              <blockquote className="text-xl md:text-2xl font-medium text-white italic mb-8" data-id="element-287">
                "My goal wasn't another complicated tool, but a system that
                sales teams actually want to use because it takes work off their
                plate instead of creating more."
              </blockquote>
              <div className="flex items-center gap-4" data-id="element-288">
                <div className="w-12 h-12 rounded-full bg-[#FF5722] flex items-center justify-center text-white font-bold" data-id="element-289">
                  JK
                </div>
                <div data-id="element-290">
                  <div className="font-bold text-white" data-id="element-291">Justus Kraft</div>
                  <div className="text-sm text-[#94A3B8]" data-id="element-292">
                    Founder CRM Kraft
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}